module.exports = ".compensation-container {\n  padding: 15px 0; }\n  .compensation-container form {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    width: 260px; }\n  .compensation-container form mat-form-field {\n      margin: 5px 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/driver-tariffs/compensation-tab/compensation-tab.component.scss
// module id = ./src/app/driver-tariffs/compensation-tab/compensation-tab.component.scss
// module chunks = main